import { CRITICAL, DEBUG, ERROR, INFO, SILENT, VERBOSE, WARN } from '../helpers/logLevels';

/**
 * Map of all available log levels
 * @type {Object<String>}
 */
const LOG_LEVELS = {
    DEBUG,
    VERBOSE,
    INFO,
    WARN,
    ERROR,
    CRITICAL,
    SILENT
};

export default LOG_LEVELS;
